module.exports = __webpack_public_path__ + "img/Trupp_TS.914ef5b6.svg";